s
<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        <li style="font-size: 13px; flex: 1">
          {{
            state.model?.name +
            (state.model?.check_status === 0 && $judge_auth("137")
              ? "-异卡发放审核"
              : "-异卡申请记录")
          }}
        </li>
      </ul>
      <div style="display: flex; height: 100%; overflow: hidden; padding: 10px">
        <div
          style="
            display: flex;
            height: 100%;
            overflow: hidden;
            flex: 1;
            flex-direction: column;
          "
        >
          <ul
            style="font-weight: 600; font-size: 12px; color: rgba(0, 0, 0, 0.6)"
          >
            基本信息
          </ul>
          <el-descriptions
            :column="
              state.model?.check_status === 0 && $judge_auth('137') ? 3 : 4
            "
            border
            style="overflow-x: auto; margin-top: 10px"
            class="desc-label-nowrap"
          >
            <el-descriptions-item label="状态" label-align="right">
              <div style="min-width: 200px">
                <c_status
                  v-if="
                    state.model.check_status != null &&
                    state.model.check_status != undefined
                  "
                  arr-name="diffbank_check_status"
                  :value="state.model?.check_status"
                ></c_status>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="姓名" label-align="right">
              <div style="min-width: 200px">
                {{ state.model.name || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="证件号" label-align="right">
              <div style="min-width: 200px">
                {{ state.model.idcard || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="所属客服" label-align="right">
              <div style="min-width: 200px">
                {{ state.model.add_admin_name || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="扣缴义务人" label-align="right">
              <div style="min-width: 200px">
                {{ state.model.withholding_agent_name || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="异卡户名" label-align="right">
              <div style="min-width: 200px">
                {{ state.model.bank_account_name || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="异卡开户行" label-align="right">
              <div style="min-width: 200px">
                {{ state.model.opening_bank || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="异卡账户" label-align="right">
              <div style="min-width: 200px">
                {{ state.model.bank_account || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="申请说明" label-align="right">
              <div style="min-width: 200px">
                {{ state.model.reason || "-" }}
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <template v-if="state.model.attachment?.length > 0">
            <ul
              style="
                font-weight: 600;
                font-size: 12px;
                margin-top: 10px;
                color: rgba(0, 0, 0, 0.6);
              "
            >
              申请附件
            </ul>
            <div style="width: 100%">
              <ul
                v-for="item in state.model.attachment"
                :key="item"
                class="diffbank-detail-files"
              >
                <li
                  style="color: #1e90ff; text-decoration: underline"
                  @click="toFile(item)"
                >
                  {{ item.filename }}
                </li>
              </ul>
            </div>
          </template>
          <template v-if="state.model.check_status !== 0">
            <ul
              style="
                font-weight: 600;
                font-size: 12px;
                color: rgba(0, 0, 0, 0.6);
                margin-top: 10px;
              "
            >
              审核信息
            </ul>
            <el-descriptions
              :column="2"
              border
              style="overflow-x: auto; margin-top: 10px"
              class="desc-label-nowrap"
            >
              <el-descriptions-item label="审核状态" label-align="right">
                <div style="min-width: 200px">
                  <c_status
                    v-if="state.model.id"
                    arrName="diffbank_check_status"
                    :value="state.model.check_status"
                  />
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="审核人" label-align="right">
                <div style="min-width: 200px">
                  {{ state.model.check_admin_name || "-" }}
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="审核时间" label-align="right">
                <div style="min-width: 200px">
                  {{ state.model.check_time || "-" }}
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="审核意见" label-align="right">
                <div style="min-width: 200px">
                  {{ state.model.check_msg || "-" }}
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <template v-if="state.model.check_attachment?.length > 0">
              <ul
                style="
                  font-weight: 600;
                  font-size: 12px;
                  margin-top: 10px;
                  color: rgba(0, 0, 0, 0.6);
                "
              >
                审核附件
              </ul>
              <div style="width: 100%">
                <ul
                  v-for="item in state.model.check_attachment"
                  :key="item"
                  class="diffbank-detail-files"
                  style="margin-top: 10px"
                >
                  <li
                    style="color: #1e90ff; text-decoration: underline"
                    @click="toFile(item)"
                  >
                    {{ item.filename }}
                  </li>
                </ul>
              </div>
            </template>
          </template>
          <!-- <ul
            style="
              font-weight: 600;
              font-size: 12px;
              margin-top: 10px;
              color: rgba(0, 0, 0, 0.6);
            "
          >
            操作记录
          </ul>
          <el-table
            ref="tableDom"
            :data="state.tableData"
            v-loading="!Array.isArray(state.tableData)"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            style="margin-top: 10px"
          >
            <el-table-column type="selection" width="55" fixed />
            <el-table-column
              fixed
              label="序号"
              width="50"
              type="index"
              :index="
                (index) =>
                  (state.params.page - 1) * state.params.limit + index + 1
              "
              align="center"
            />
            <el-table-column
              label="操作时间"
              prop="update_time"
              width="100"
              :formatter="$tab_TextFormat"
              fixed="left"
            />
            <el-table-column
              prop="remark"
              label="备注"
              :formatter="$tab_ShowToolTip"
              min-width="140"
            />
          </el-table> -->
        </div>
        <div
          style="
            width: 30%;
            padding-left: 10px;
            display: flex;
            flex-direction: column;
          "
          v-if="state.model.check_status === 0 && $judge_auth('137')"
        >
          <el-form
            :model="state.checkModel"
            ref="formDom"
            label-position="top"
            style="width: 100%"
          >
            <el-form-item
              label="审核意见"
              prop="check_msg"
              :rules="[
                { required: true, message: '请填写审核意见', trigger: 'blur' },
              ]"
            >
              <el-input
                type="textarea"
                v-model="state.checkModel.check_msg"
              ></el-input>
            </el-form-item>
            <el-form-item label="盖章附件" label-width="300px">
              <template #label>
                <div
                  style="display: flex; align-items: center; column-gap: 10px"
                >
                  <text>盖章附件</text>
                  <el-upload
                    :show-file-list="false"
                    :auto-upload="false"
                    :multiple="true"
                    :on-change="onChangeFile"
                  >
                    <template #trigger>
                      <el-button type="primary" size="small">上传</el-button>
                    </template>
                  </el-upload>
                </div>
              </template>
              <div
                v-if="state.files.length <= 0"
                style="text-align: center; color: #a2a2a2"
              >
                请点击"上传"按钮上传相关文件~
              </div>
              <div v-else style="width: 100%">
                <ul
                  v-for="(item, index) in state.files"
                  :key="item"
                  class="diffbank-detail-files"
                  style="cursor: pointer"
                  @click="toFile(item)"
                >
                  <li style="flex: 1">{{ item.origin_filename }}</li>
                  <el-icon @click="state.files.splice(index, 1)" color="#f00"
                    ><CloseBold
                  /></el-icon>
                </ul>
              </div>
            </el-form-item>
            <el-form-item label="">
              <div
                style="display: flex; justify-content: flex-end; width: 100%"
              >
                <el-button type="danger" @click="onSubmit(false)">
                  审核不通过
                </el-button>
                <el-button type="primary" @click="onSubmit(true)">
                  审核通过
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { diffbank_detail, diffbank_check } from "@/http/diffbank";
import { ElMessageBox, ElMessage } from "element-plus";
import { attachment_upload } from "@/http/attachment";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
      activeName: "record",
      checkModel: {},
      files: [],
    });
    onMounted(() => {
      onLoad();

      state.tableData = [];
    });

    const onLoad = () => {
      diffbank_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    };

    const onChangeFile = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          res.data.data.forEach((e) => {
            state.files.push(e);
          });
        }
      });
    };

    const onSubmit = (res) => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (res) {
            ElMessageBox.confirm(
              `您确定<strong style='color:#080'>同意</strong>员工<strong style='color:#1e90ff'>${state.model.name}</strong>的异卡发放申请？`,
              "审核确认",
              {
                confirmButtonText: "确定审核",
                cancelButtonText: "取消",
                type: "warning",
                dangerouslyUseHTMLString: true,
              },
            ).then(() => {
              const data = {
                id: props.data?.id,
                check_status: 1,
                check_msg: state.checkModel.check_msg,
                check_attachment: state.files?.map((e) => e.id).join(","),
              };
              diffbank_check(data).then((res) => {
                if (res.status == 200) {
                  ElMessage.success(res.data.msg);
                  onLoad();
                }
              });
            });
          } else {
            ElMessageBox.confirm(
              `您确定<strong style='color:#f00'>拒绝</strong>员工<strong style='color:#1e90ff'>${state.model.name}</strong>的异卡发放申请？`,
              "审核确认",
              {
                confirmButtonText: "确定拒绝",
                confirmButtonClass: "el-button--danger",
                cancelButtonText: "取消",
                type: "warning",
                dangerouslyUseHTMLString: true,
              },
            ).then(() => {
              const data = {
                id: props.data?.id,
                check_status: 2,
                check_msg: state.checkModel.check_msg,
                check_attachment: state.files?.map((e) => e.id).join(","),
              };
              diffbank_check(data).then((res) => {
                if (res.status == 200) {
                  ElMessage.success(res.data.msg);
                  onLoad();
                }
              });
            });
          }
        }
      });
    };

    const toFile = (item) => {
      window.open(item.file_url, "_blank");
    };

    return { state, props, onSubmit, formDom, onChangeFile, toFile };
  },
};
</script>
<style scoped>
.diffbank-detail-files {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.7);

  &:hover {
    color: #a2a2a2;
  }
}
</style>
